import {useRef, useState} from 'preact/hooks'

import Image from './Image'
import Layout from "./Layout";
import CommonTitle from "./CommonTitle";
import classes from "./Tools.module.css";

import insure_img from '../assets/tools/bx.png'
import company_img from '../assets/tools/qy.png'

// 企业
import bzhgj from '../assets/tools/qy/qy-bzhgj.png'
import wxygk from '../assets/tools/qy/qy-wxygk.png'
import fxfx from '../assets/tools/qy/qy-fxfx.png'
import zxkt from '../assets/tools/qy/qy-zxkt.png'
import hdwd from '../assets/tools/qy/qy-hdwd.png'
import yjzy from '../assets/tools/qy/qy-yjzy.png'
import yhzl from '../assets/tools/qy/qy-yhzl.png'
import zxzj from '../assets/tools/qy/qy-zxzj.png'

// 保险
import zjfk from '../assets/tools/bx/bx-zjfk.png'
import abhd from '../assets/tools/bx/bx-abhd.png'
import fxyj from '../assets/tools/bx/bx-fxyj.png'
import fkbg from '../assets/tools/bx/bx-fkbg.png'
import hyfx from '../assets/tools/bx/bx-hyfx.png'
import yhfl from '../assets/tools/bx/bx-yhfl.png'
import fxpc from '../assets/tools/bx/bx-fxpc.png'
import bqfk from '../assets/tools/bx/bx-bqfk.png'


const company_icon_list = [
	{
		title: '标准化工具',
		src: bzhgj
	},
	{
		title: '危险源管控',
		src: wxygk
	},
	{
		title: '风险分析',
		src: fxfx
	},
	{
		title: '在线课堂',
		src: zxkt
	},
	{
		title: '互动问答',
		src: hdwd
	},
	{
		title: '应急资源',
		src: yjzy
	},
	{
		title: '隐患治理',
		src: yhzl
	},
	{
		title: '在线专家',
		src: zxzj
	}
]

const insure_icon_list = [
	{
		title: '专家风堪',
		src: zjfk
	},
	{
		title: '安保互动',
		src: abhd
	},
	{
		title: '风险预警',
		src: fxyj
	},
	{
		title: '风控报告',
		src: fkbg
	},
	{
		title: '行业分析',
		src: hyfx
	},
	{
		title: '优化费率',
		src: yhfl
	},
	{
		title: '风险排查',
		src: fxpc
	},
	{
		title: '保前风堪',
		src: bqfk
	}
]
export default function Tools({id}) {

	const tool_content_area_ele = useRef(null);
	const company_icon_list_ele = useRef(null);

	const [iconList = [], toggle, setIconList,] = useToggle([company_icon_list, insure_icon_list], insure_icon_list);


	let timer = null;
	let fade_timer = null;

	function slowlyOpen(callback) {
		clearInterval(timer);
		const speed = 5;
		const target = 1100;
		let count = 0;
		timer = setInterval(() => {
			const current = getPX(tool_content_area_ele.current.style.width, 600);
			if (current < target - speed) {
				tool_content_area_ele.current.style.width = `${current + speed}px`
				count++;
			} else {
				clearInterval(timer);

				company_icon_list_ele.current.style.display = 'flex';

				// count 标识 定时器触发的次数
				// count过小代表快速触发到达临界值，不设置渐入动画，否则会表现画面抖动
				if(count>20){
					company_icon_list_ele.current.style.opacity = 0;
					setTimeout(() => {
						fadeIn(company_icon_list_ele.current)
					}, 0)
				}else{
					console.log('count,ele',count)
					company_icon_list_ele.current.style.display = 'flex';
					company_icon_list_ele.current.style.opacity = 1;
				}

			}
		}, 10)
	}


	function slowlyClose() {
		company_icon_list_ele.current.style.opacity = 0;
		company_icon_list_ele.current.style.display = 'none';

		clearInterval(timer);
		const speed = 5;
		const target = 600;
		timer = setInterval(() => {
			const current = getPX(tool_content_area_ele.current.style.width, 1100);
			if (current > target + speed) {
				tool_content_area_ele.current.style.width = `${current - speed}px`
			} else {
				clearInterval(timer);
			}
		}, 10)
	}

	function getPX(str, replaceNull) {
		if (!str) return Number(replaceNull);
		if (str.includes('px')) {
			return Number(str.replace('px', ''));
		}
	}

	function fadeIn(dom) {
		clearInterval(fade_timer);
		let opacity = 0;
		let speed = 0.01;
		fade_timer = setInterval(() => {
			if (opacity < 1 - speed) {
				opacity += speed
				dom.style.opacity = opacity;
			} else {
				clearInterval(fade_timer)
			}
		}, 10)
	}

	function fadeOut(dom) {
		clearInterval(fade_timer);
		let opacity = 1;
		let speed = 0.1;
		fade_timer = setInterval(() => {
			if (opacity > 0 + speed && opacity - speed >= 0) {
				opacity -= 0.1
				dom.style.opacity = opacity;
			} else {
				clearInterval(fade_timer)
			}
		}, 100)
	}


	function on_company_mouseOver() {
		slowlyOpen();
		setIconList(company_icon_list)
	}

	function on_insurance_mouseOver() {
		slowlyOpen();
		setIconList(insure_icon_list)
	}

	console.log('iconList', iconList)
	return (
		<Layout id={id}>
			<CommonTitle title="工具"/>
			<div className={classes['tool-content-area']} ref={tool_content_area_ele} onMouseLeave={slowlyClose}>
				{/*企业icon*/}
				<div className={`${classes['tool-icon']} ${classes['company-icon']}`}>
					<div className={classes['img-content']} onMouseOver={on_company_mouseOver}>
						<div className={classes['company-img']}>
							<Image src={company_img} priority alt="企业"/>
							{/* 圆环 */}
							<div className={classes['company-icon-circle']}></div>
						</div>

						<p>企业</p>
					</div>
				</div>

				<div className={`${classes['tool-icon-list']}`} ref={company_icon_list_ele}>
					{
						iconList.map((item, index) => (
							<div key={index}>
								<Image src={item.src} alt={item.title}/>
							</div>
						))
					}
				</div>

				{/* insure icon */}
				<div className={`${classes['tool-icon']} ${classes['insure-icon']}`}>
					<div className={classes['img-content']}>
						<div className={classes['insure-img']} onMouseOver={on_insurance_mouseOver}>
							<Image src={insure_img} priority alt="保险"/>
							{/* 圆环 */}
							<div className={classes['insurance-icon-circle']}></div>
						</div>
						<p>保险</p>
					</div>
				</div>
			</div>
		</Layout>
	)
}


function useToggle([arg1, arg2], defaultValue) {
	const [state, setState] = useState(defaultValue);

	function toggle() {
		if (state === JSON.stringify(arg1)) {
			setState(arg2)
		} else {
			setState(arg1)
		}
	}

	function set(arg3) {
		if (JSON.stringify(state) !== arg3) {
			setState(arg3)
		}
	}

	return [state, toggle, set]
}
